import {
  PrimaryButton,
  PrimaryDestructiveButton,
  PrimaryInverseButton,
  SecondaryButton,
  SecondaryInverseButton,
  TertiaryButton,
  TertiaryInverseButton,
  TextButton,
  TextDestructiveButton,
  TextInverseButton,
} from './Button.styles';
import { ButtonProps, ButtonPriority, ButtonVariant } from './Button.types';

export const Button = ({
  priority = 'primary',
  variant = 'primary',
  size = 'large',
  hover = false,
  ...rest
}: ButtonProps) => {
  rest.className += hover ? ' hover' : '';
  const buttonProps = {
    ...rest,
    priority,
    variant,
    size,
  };

  const buttons: {
    [key in ButtonPriority]: { [variant in ButtonVariant]: () => JSX.Element };
  } = {
    primary: {
      primary: () => <PrimaryButton {...buttonProps} />,
      inverse: () => <PrimaryInverseButton {...buttonProps} />,
      destructive: () => <PrimaryDestructiveButton {...buttonProps} />,
    },
    secondary: {
      primary: () => <SecondaryButton {...buttonProps} />,
      inverse: () => <SecondaryInverseButton {...buttonProps} />,
      destructive: () => <PrimaryDestructiveButton {...buttonProps} />,
    },
    tertiary: {
      primary: () => <TertiaryButton {...buttonProps} />,
      inverse: () => <TertiaryInverseButton {...buttonProps} />,
      destructive: () => <PrimaryDestructiveButton {...buttonProps} />,
    },
    text: {
      primary: () => <TextButton {...buttonProps} />,
      inverse: () => <TextInverseButton {...buttonProps} />,
      destructive: () => <TextDestructiveButton {...buttonProps} />,
    },
  };
  const bType = buttons[priority] ?? buttons.primary;
  const bVariant = bType[variant] ?? bType.primary;
  return bVariant();
};
